import Vue from "ninenine-white-label/Vue";
import Router from "vue-router";
import store from "./store/store";
import Page from "./views/Page.vue";
import Job from "./views/Job.vue";
import Subscription from "./views/Subscription/Subscription.vue";
import SubscriptionForm from "./views/Subscription/SubscriptionForm.vue";
import Tests from "./views/Subscription/Tests.vue";
import PendingTests from "./views/Subscription/PendingTests.vue";
import OnlineTest from "./views/Subscription/OnlineTest.vue";
import CoverTest from "./views/Subscription/CoverTest.vue";
import SubscriptionSuccessReturn from "./views/SubscriptionSuccessReturn.vue";
import SubscriptionErrorReturn from "./views/SubscriptionErrorReturn.vue";
import NotFound from "./views/404.vue";
import EliminatedByQuestions from "./views/EliminatedByQuestions.vue";
import UpdateProfile from "@/views/UpdateProfile.vue";
import ReturnTest from './views/Subscription/ReturnTest.vue';
import RegisterProfile from './views/RegisterProfile.vue';
import api from '@/data.json'

Vue.use(Router);

const router = new Router({
  routes: [
    ...((api.pages || []).map((p) => ({
      path: p.url,
      name: p.slug,
      component: Page,
      meta: {
        requiresAuth: p.requires_auth || false,
      },
    }))),

    {
      path: '/password-recovery',
      name: 'password-recovery',
      // component: Login,
      beforeEnter: (to, from, next) => {
        store.commit('DEVISE_FORM', 'change-password');
        next();
      },
    },

    {
      path: "/go-to-test",
      name: "go-to-test",
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        const testId = to.query.testId
        const challengeBackTo = to.query.challengeBackTo

        // Em Eleven criar a url com encodeURIComponent()
        // /go-to-test?testId=2015&challengeBackTo=%2Fgo-to-test%3FtestId%3D2018%26challengeBackTo%3D%2Ffinish

        if(testId && challengeBackTo){
          window.challengeBackTo = challengeBackTo;

          store.dispatch('tests/subscriptionRecentTests', {
            companyId: store.state.companyId,
            testIds: [testId]
          }).then((_tests) => {
            var tests = _tests.subscriptionRecentTests.json || [];
            
            if(tests.length == 0){
              Vue.prototype.$swal("Uoops", "Nenhum teste encontrado.", "error")
              next('/')
              return;
            }

            
            var test = tests[0]
            var testOpportunity = test.opportunity_id

            if(test.status == 'finished'){
              next(challengeBackTo)
              return;
            }

            store.dispatch("tests/testCover", {
              opportunityId: testOpportunity,
              testId: testId,
            }).then((_cover) => {
              let { first_question } = _cover.testCover.json.header_test.links;
              first_question = first_question.match(/\d+/g, " ")[3];
              const header_test = _cover.testCover.json.header_test;

              next(`/vagas/${testOpportunity}/inscricao/${header_test.id}/teste/${first_question}`)
            })
          })
        } else {
          Vue.prototype.$swal("Uoops", "Nenhum teste informado.", "error")
          next('/')
        }
      }
    },

    {
      path: "/resultado",
      name: "resultado",
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        const testId = to.query.testId

        if(testId){
          store.dispatch('tests/subscriptionRecentTests', {
            companyId: store.state.companyId,
            testIds: [testId]
          }).then((_tests) => {
            var tests = _tests.subscriptionRecentTests.json || [];
            
            if(tests.length == 0){
              Vue.prototype.$swal("Uoops", "Nenhum resultado encontrado.", "error")
              next('/')
              return;
            }

            let score = tests[0]['score']
            if(!isNaN(parseFloat(score))){
              score = parseFloat(score)
              
              if(score > 0 && score <= 29){
                next(`/resultado/0_29?testId=${testId}`)
              } else if(score >= 30 && score <= 59){
                next(`/resultado/30_59?testId=${testId}`)
              } else if(score >= 60 && score <= 79){
                next(`/resultado/60_79?testId=${testId}`)
              } else if(score >= 80 && score <= 100){
                next(`/resultado/80_100?testId=${testId}`)
              }
            }
          })
        } else {
          Vue.prototype.$swal("Uoops", "Nenhum teste informado.", "error")
          next('/')
        }
      }
    },

    {
      path: "/vagas/:id",
      name: "job",
      component: Job,
      meta: {
        surveyController: 'opportunity'
      }
    },

    {
      path: "/vagas/:id/inscricao",
      component: Subscription,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "ficha",
          component: SubscriptionForm,
          meta: { requiresAuth: true, surveyController: 'subscription' },
        },

        {
          path: "testes",
          name: "testes",
          component: Tests,
          meta: { requiresAuth: true }
        },

        {
          path: "testes-pendentes",
          name: "pending-tests",
          component: PendingTests,
          meta: { requiresAuth: true }
        },

        {
          path: ":testName/:testId",
          name: "capa-teste",
          component: CoverTest,
          meta: { requiresAuth: true }
        },

        {
          path: ":headerTestId/teste/:first_question",
          name: "teste",
          component: OnlineTest,
          meta: { requiresAuth: true },
        }
      ]
    },

    {
      path: "/return_test/:user_id/:source_test_id/:opportunity_id",
      name: "return-test",
      component: ReturnTest,
    },

    {
      path: "/inscricao",
      name: "inscricao",
      component: Subscription,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (store.state.user.isAuth) {
          let goTo = to.query.url;
          let indication = to.query.indication ? "&source=indication" : "";

          let uri = goTo.split("/");
          let name = uri[uri.length - 1];
          let id = name.match(/\d+/)[0];
          let already =
            store.state.opportunities.subscriptions.indexOf(id) !== -1;

          if (already == false) {
            goTo = goTo.replace(
              "https://www.99jobs.com",
              Vue.prototype.DELTA_ENDPOINT
            );
            goTo += `/subscriptions/external_application?candidate_id=${store.state.user.profile.id}&return_url=${window.location.origin}&preview_url=${window.location.pathname}${indication}`;

            location.href = goTo;
          }
        } else {
          next();
        }
      }
    },

    {
      path: "/deixe-seu-perfil",
      name: "deixe-seu-perfil",
      component: RegisterProfile,
      meta: { requiresAuth: true }
    },

    // {
    //   path: "/accept_hunting/:token",
    //   name: "accept_hunting",
    //   component: AcceptHunting
    // },

    // {
    //   path: "/meu-perfil",
    //   name: "meu-perfil",
    //   component: Profile,
    //   meta: { requiresAuth: true }
    // },

    {
      path: "/erro-inscricao",
      name: "erro-inscricao",
      component: SubscriptionErrorReturn,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/inscricao-confirmada",
      name: "inscricao-confirmada",
      component: SubscriptionSuccessReturn,
      meta: {
        requiresAuth: true,
        surveyController: 'thank_you'
      }
    },

    {
      path: "/inscricao-recusada",
      name: "inscricao-recusada",
      component: EliminatedByQuestions,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/inscricao-retorno",
      name: "inscricao-retorno",
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (to.query.status == 200) {
          next(`/inscricao-confirmada?vaga=${to.query.vaga}`);
        } else {
          next(`/erro-inscricao`);
        }
      }
    },

    {
      path: "/linkedin-return",
      name: "linkedin-return",
      beforeEnter: (to, from, next) => {
        const url_string = window.location.href;
        const url = new URL(url_string);
        const code = url.searchParams.get("code");
        const error = url.searchParams.get("error");

        if (to.query.back_to) {
          localStorage.setItem("back_to", to.query.back_to);
        }

        if (code || error) {
          if (localStorage.getItem("back_to")) {
            let params = window.location.search;
            if (params.indexOf("?code=") !== -1) {
              params = params.replace("?code=", "&code=");
            }
            next(localStorage.getItem("back_to") + params);
          }
        } else {
          const return_url = window.location.origin + "/linkedin-return";
          window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${Vue.prototype.socialIds.linkedin}&redirect_uri=${return_url}&scope=r_liteprofile%20r_emailaddress`;
        }
      }
    },

    {
      path: "/profile_questions_updates/token/:token",
      name: "atualizacao-perfil",
      component: UpdateProfile,
      meta: {
        requiresAuth: true
      },
    },

    {
      path: "*",
      name: "not-found",
      component: NotFound
    }
  ],

  mode: "history",

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

router.beforeEach((to, from, next) => {
  store.commit("DEVISE_FORM", null);

  if (from.name == null) {
    localStorage.removeItem("allFilters");
  }

  if(Vue.prototype.$session.exists() && typeof NineNineSurveys !== 'undefined'){
    setTimeout(() => {
      if(store.state.user.profile && store.state.user.profile.id){
        const decriptUid = Vue.prototype.$encrypts.decrypt(
          store.state.user.profile.id,
          store.state.tkn
        );
        if(decriptUid){
          NineNineSurveys.setUserId(decriptUid);
        }
      }
      if(to.params.id){
        NineNineSurveys.setCurrentOpportunityId(to.params.id.match(/\d+/)[0]);
      } else {
        NineNineSurveys.setCurrentOpportunityId(null);
      }
      
      NineNineSurveys.setAPIEndpoint(process.env.VUE_APP_API_ENDPOINT + '/graphql');
      NineNineSurveys.init(process.env.VUE_APP_API_TOKEN);
      NineNineSurveys.setCompanyId(store.state.companyId);
      NineNineSurveys.setPlatform('wl');
      if(to.meta.surveyController){
        NineNineSurveys.setCurrentController(to.meta.surveyController);
        NineNineSurveys.setCurrentAction('index');
        NineNineSurveys.logEvent('pageView');
        NineNineSurveys.checkSurvey();
      }
    }, 500)
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!Vue.prototype.$session.exists()) {
      let { path, query } = from;
      next({
        path: path,
        query: query
      });

      store.commit("DEVISE_FORM", api.type == 'ri' ? 'pre-login-ri' : "login");
      store.commit("user/SET_NEXT_ROUTE", to);
    } else {
      next();
      store.commit("user/SET_NEXT_ROUTE", null);
    }
  } else {
    next();
  }
});

export default router;